/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { JofiCreatePartnerDto } from '../models/jofi-create-partner-dto';
import { JofiPartner } from '../models/jofi-partner';
import { JofiUpdatePartnerDto } from '../models/jofi-update-partner-dto';

@Injectable({
  providedIn: 'root',
})
export class JofiAdminPartnersService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation partnersAdminControllerFindAll
   */
  static readonly PartnersAdminControllerFindAllPath = '/v1/admin/partners';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `partnersAdminControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  partnersAdminControllerFindAll$Response(params?: {
    context?: HttpContext
  }
): Observable<StrictHttpResponse<Array<JofiPartner>>> {

    const rb = new RequestBuilder(this.rootUrl, JofiAdminPartnersService.PartnersAdminControllerFindAllPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<JofiPartner>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `partnersAdminControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  partnersAdminControllerFindAll(params?: {
    context?: HttpContext
  }
): Observable<Array<JofiPartner>> {

    return this.partnersAdminControllerFindAll$Response(params).pipe(
      map((r: StrictHttpResponse<Array<JofiPartner>>) => r.body as Array<JofiPartner>)
    );
  }

  /**
   * Path part for operation partnersAdminControllerCreate
   */
  static readonly PartnersAdminControllerCreatePath = '/v1/admin/partners';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `partnersAdminControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  partnersAdminControllerCreate$Response(params: {
    context?: HttpContext
    body: JofiCreatePartnerDto
  }
): Observable<StrictHttpResponse<JofiPartner>> {

    const rb = new RequestBuilder(this.rootUrl, JofiAdminPartnersService.PartnersAdminControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<JofiPartner>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `partnersAdminControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  partnersAdminControllerCreate(params: {
    context?: HttpContext
    body: JofiCreatePartnerDto
  }
): Observable<JofiPartner> {

    return this.partnersAdminControllerCreate$Response(params).pipe(
      map((r: StrictHttpResponse<JofiPartner>) => r.body as JofiPartner)
    );
  }

  /**
   * Path part for operation partnersAdminControllerUpdate
   */
  static readonly PartnersAdminControllerUpdatePath = '/v1/admin/partners/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `partnersAdminControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  partnersAdminControllerUpdate$Response(params: {
    id: string;
    context?: HttpContext
    body: JofiUpdatePartnerDto
  }
): Observable<StrictHttpResponse<JofiPartner>> {

    const rb = new RequestBuilder(this.rootUrl, JofiAdminPartnersService.PartnersAdminControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<JofiPartner>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `partnersAdminControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  partnersAdminControllerUpdate(params: {
    id: string;
    context?: HttpContext
    body: JofiUpdatePartnerDto
  }
): Observable<JofiPartner> {

    return this.partnersAdminControllerUpdate$Response(params).pipe(
      map((r: StrictHttpResponse<JofiPartner>) => r.body as JofiPartner)
    );
  }

}
